import BankerRecommendations from './BankerRecommendations';

export default BankerRecommendations;
